module.exports = __webpack_public_path__ + "static/media/18_digginglight.3ab68e17.jpg";